import { motion } from 'framer-motion';
import { Lock, Shield, Clock, Users } from 'lucide-react';
import { fadeInUp, stagger } from './data';

const SECURITY_ITEMS = [
  { icon: Lock, text: 'Multi-Factor Auth (MFA)' },
  { icon: Shield, text: 'Encrypted Data Transfer' },
  { icon: Clock, text: 'Daily Backups' },
  { icon: Users, text: 'Role-based Access' },
];

export const SecuritySection = () => (
  <section className="py-20 md:py-32 bg-neutral-900/50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
          <motion.div variants={fadeInUp} className="flex items-center gap-3 mb-4">
            <Shield className="w-6 h-6 text-green-400" />
            <span className="text-green-400 font-semibold">SECURITY & COMPLIANCE</span>
          </motion.div>
          <motion.h2 variants={fadeInUp} className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Your Financial Data is Safe
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-gray-400 text-lg mb-8">
            We understand you're trusting us with sensitive financial data. That's why
            we use enterprise-grade security at every level.
          </motion.p>
          <motion.div variants={stagger} className="grid grid-cols-2 gap-6">
            {SECURITY_ITEMS.map((item) => (
              <motion.div key={item.text} variants={fadeInUp} className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center">
                  <item.icon className="w-5 h-5 text-green-400" />
                </div>
                <span className="text-gray-300 text-sm">{item.text}</span>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="relative"
        >
          <div className="bg-neutral-900 rounded-2xl border border-amber-500/20 p-8 md:p-12">
            <div className="flex items-center justify-center gap-8 flex-wrap">
              <div className="text-center">
                <div className="text-4xl font-black text-amber-400 mb-2">99.9%</div>
                <div className="text-sm text-gray-400">Uptime SLA</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-black text-green-400 mb-2">256-bit</div>
                <div className="text-sm text-gray-400">SSL Encryption</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-black text-yellow-400 mb-2">MFA</div>
                <div className="text-sm text-gray-400">Secure Login</div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
